// eslint-disable-next-line import/no-anonymous-default-export
export default {
  brandGrey: {
    900: '#1a365d',
    800: '#153e75',
    700: '#2a69ac',
  },
  wht: {
    '50': '#fff',
    '100': '#fff',
    '200': '#fff',
    '300': '#fff',
    '400': '#fff',
    '500': '#fff',
    '600': '#fff',
    '700': '#fff',
    '800': '#fff',
    '900': '#fff',
  },
  secondary: {
    '50': '#fff3e0',
    '100': '#ffe0b2',
    '200': '#ffcd80',
    '300': '#ffb84d',
    '400': '#ffa826',
    '500': '#ff9900',
    '600': '#fb8d00',
    '700': '#f57d00',
    '800': '#ef6d00',
    '900': '#e65200',
  },
  primary: {
    '50': '#e6e9f3',
    '100': '#bfc7e2',
    '200': '#95a3ce',
    '300': '#6b80ba',
    '400': '#4965ad',
    '500': '#214ca0',
    '600': '#1a4497',
    '700': '#0c3b8c',
    '800': '#003180',
    '900': '#00216c',
  },
  primaryColor: {
    main: '#4965ad',
    shadowInset: '#1a4497',
    highlightInset: '#6b80ba',
    light: '#95a3ce',
    dark: '#0c3b8c',
    reallyDark: '#003180',
  },
  secondaryColor: {
    main: '#ff9900',
    shadowInset: '#fb8d00',
    highlightInset: '#ffb84d',
    dark: '#f57d00',
  },
  bg: {
    main: "#f6f6f6",
  },
  button: {
    contrast: '#fff',
    shadow: '3333335c',
  },
};
